/* import __COLOCATED_TEMPLATE__ from './state-change-summary.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();